export const APP_MESSAGES = {
  COMMON_MSG: {
    SEARCH_HINT_TEXT: "Press enter to search",
  },
  SEASON_ADDED: "Season Added Successfully.",
  SEASON_UPDATE: "Season Updated Successfully.",
  SEASON_ALREADY_EXIST: "Season Already Exists.",
  CROP_ADDED: "Crop Added Successfully.",
  CROP_UPDATE: "Crop Updated Successfully.",
  CROP_ALREADY_EXIST: "Crop Already Exists.",
  LOCATION_ADDED: "Location Added Successfully.",
  LOCATION_UPDATE: "Location Updated Successfully.",
  LOCATION_ALREADY_EXIST: "Location Already Exists.",
  LOCATION_DELETED: "Location Deleted Successfully.",
  PRODUCT_ADDED: "Product Added Successfully.",
  PRODUCT_ALREADY_EXIST: "Product Already Exists.",
  PRODUCT_UPDATE: "Product Updated Successfully.",
  PRODUCTS_UPDATE: "Products Updated Successfully.",
  PRODUCT_DELETED: "Product Deleted Successfully.",
  PRODUCTS_DELETED: "Products Deleted Successfully.",
  PRODUCT_APPROVED: "Product Approved Successfully",
  PRODUCT_COMBINE: "Product Combined Succesfully.",
  PRODUCT_STATUS_UPDATED: "Product Status Updated Successfully",
  USER_ADDED: "User Added Successfully.",
  USER_UPDATE: "User Updated Successfully.",
  USER_ALREADY_EXIST: "User Already Exists.",
  USER_DELETED: "User Deleted Successfully.",
  USER_DELETE_FAILURE: "Failed to delete user",
  TREATMENT_PRODUCT_DELETE_FAILURE: "Failed to delete treatment product",
  TREATMENT_PRODUCT_DELETED: "Treatment Product Deleted Successfully.",
  TREATMENT_PRODUCT_ALREADY_EXIST: "Treatment Product Already Exists.",
  TREATMENT_PRODUCT_ADDED: "Treatment Product Added Successfully.",
  TREATMENT_PRODUCT_UPDATE: "Treatment Product Updated Successfully.",
  TREATMENT_PRODUCT_COMBINE: "Treatment Products Combined Successfully.",
  TEAM_ADDED: "Team Added Successfully.",
  TEAM_ALREADY_EXIST: "Team Already Exists.",
  TEAM_UPDATE: "Team Updated Successfully.",
  TEAM_DELETED: "Team Deleted Successfully.",
  ADD_INVENTORY_PRODUCT: "Product Added Successfully.",
  TREATMENT_DELETED: "Treatment Deleted Successfully",
  ADDED_VARIENTS: "Variants Added Successfully.",
  INVENTORY_UPDATE: "Inventory Updated Successfully.",
  INVENTORY_DELETED: "Inventory Deleted Successfully.",
  TRIAL_PUBLISH_SUCCESS: "Trial Published Successfully.",
  TRIAL_PUBLISH_FAILURE: "Trial Published failed. Please try after some time.",
  TRIAL_CREATE_SUCCESS: "Trial Created Successfully.",
  TRIAL_UPDATE_SUCCESS: "Trial Updated Successfully.",
  TRIAL_ALREADY_EXIST: "Trial with this name already exists.",
  TRIAL_DELETE_SUCCESS: "Trial Deleted Successfully.",
  TRIAL_LOCATION_ALREADY_EXIST:
    "Trial Location associated with this master location already exists.",
  TRIALLOCATION_CREATE_SUCCESS: "TrialLocation Created Successfully.",
  TRIALLOCATION_DELETED: "TrialLocation Deleted Successfully.",
  TRIALLOCATION_DELETE_FAILURE:
    "You can't delete this location because it is currently in use.",
  TRIAL_PRODUCT_UPDATE_SUCCESS: "Products Updated Successfully.",
  ADD_INVENTORY: "Inventory Added Successfully.",
  TRIAL_UNPUBLISH_SUCCESS: "Trial Unpublished Successfully.",
  MAPPING_SHEET_ALREADY_EXIST: "Worksheet Already Exists.",
  RETAILER_ACCESS_UPDATED: "Retailer access updated successfully.",
  RETAILER_ACCESS_UPDATE_FAILED: "Failed to update retailer access.",
  MAPPING_SHEET_NO_CHANGE_EXIST: "No New Changes To Save.",
  MAPPING_SHEET_CREATE_SUCCESS: "Worksheet Created Successfully.",
  TRIAL_REP_CREATE_SUCCESS: "Rep Created Successfully.",
  SUBSTITUTE_UPDATED_SUCCESS: "Product Substituted Successfully.",
  SUBSTITUTE_NOTMODIFIED_ERROR: "No Product is available to substitute.",
  DELETE_REP_SUCCESS: "Rep Deleted Successfully.",
  REP_INFO_UPDATE: "Rep Book is Updated Successfully.",
  AGRONOMIC_DATA_UPDATE_SUCCESS: "Agronomic Data Updated Successfully.",
   HARVEST_DATA_UPDATE_SUCCESS: "Harvest Data Updated Successfully.",
  FIELD_JOURNAL_UPDATE_SUCCESS: "Field Book is Updated Successfully.",
  FIELD_BOOK_UPDATE_SUCCESS: "Field Book is Updated Successfully.",
  MAPPING_SHEET_TRIAL_DELETE_SUCCESS: "Worksheet Trial Deleted Successfully.",
  MAPPING_SHEET_LOCATION_DELETE_SUCCESS:
    "Worksheet Location Deleted Successfully.",
  DEMO_INVENTORY_DELETE_SUCCESS: "Demo Inventory Deleted Successfully.",
  DEMO_INVENTORY_PRODUCT_UPDATED_SUCCESS:
    "Demo Inventory Product Updated Successfully.",
  DEMO_INVENTORY_PRODUCT_DELETED_SUCCESS:
    "Demo Inventory Product Deleted Successfully.",
  DEMO_TRIAL_DELETE_SUCCESS: "Demo Trial Deleted Successfully.",
  ADD_DEMO_PRODUCT: "Product Added Successfully.",
  DEMO_ADD_INVENTORY: "Demo Inventory Added Successfully.",
  ADD_DEMO_TRIAL: "Demo Trial Created Successfully.",
  UPDATE_DEMO_TRIAL: "Demo Trial Updated Successfully.",
  DEMO_TRIAL_PRODUCT_DELETED_SUCCESS: "Demo Product Deleted Successfully.",
  TREATMENT_UPDATED_SUCESSFULLY: "Treatment Updated Successfully.",
  TREATMENT_ALREADY_EXISTS: "Treatment Already Exists.",
  APPLICATIONS_UPDATED_SUCCESS: "Updated Successfully.",
  CROP_STAGE_REQUIRED: "CropStage is required",
  DEMO_TRIAL_ASSIGN_LOCATION_SUCCESS: "Location Assigned Successfully.",
  DEMO_TRIAL_UNASSIGN_LOCATION_SUCCESS: "Location Unassigned Successfully.",
  META_DATA_UPDATE_SUCCESS: "Meta Data Updated Successfully.",
  META_DATA_UPDATE_FAILURE: "Failed To Update Meta Data.",
  LOCATION_UPDATE_MESSAGE: "Updated Successfully.",
  REP_DELETE_ERROR: "Placed Reps Can Not Be Deleted.",
  PROTOCOL_CREATED: "Protocol Created Successfully",
  PROTOCOL_PUBLISHED: "Protocol Published Successfully.",
  PROTOCOL_SAVED_AS_DRAFT: "Protocol Save as Draft Successfully.",
  PROTOCOL_ALREADY_EXIST: "Protocol Already Exists.",
  PROTOCOL_DELETED: "Protocol Deleted Successfully.",
  DEMO_TRIAL_UNPUBLISH_SUCCESS: "Demo Trial Unpublished Successfully.",
  ADD_SOIL_SAMPLE: "Soil Sample Added Successfully.",
  SELECT_SOIL_SAMPLE: "Select Soil Sample",
  SELECT_TRIAL_REPS: "Select Trial and Reps",
  TISSUE_SAMPLE_UPDATE: "Tissue Sample Updated Successfully.",
  TISSUE_SAMPLE_ADDED: "Tissue Sample Added Successfully.",
  SOIL_SAMPLE_UPDATE: "Soil Sample Updated Successfully.",
  NEMATOD_SAMPLE_ADDED: "Nematode Sample Added Successfully.",
  NEMATOD_SAMPLE_UPDATE: "Nematode Sample Updated Successfully.",
  REP_LEVEL_UPDATE: "Rep Level Updated Successfully.",
  ENTRY_LEVEL_UPDATE: "Entry Level Updated Successfully.",
  APPLICATION_BOOK_ADDED_SUCCESS: "Application Book Added Successfully.",
  APPLICATION_BOOK_UPDATED_SUCCESS: "Application Book Updated Successfully.",
  RECORD_ENTRIES_DELETED_SUCCESS: "Records Deleted Successfully.",
  FILE_EXPORT_SUCCESS: "File Exported Successfully.",
  NOTES_ADD_SUCCESS: "Note Added Successfully.",
  NOTES_DELETE_SUCCESS: "Note Deleted Successfully.",
  NOTES_UPDATE_SUCCESS: "Note Updated Successfully.",
  FILE_IMPORT_SUCCESS: "File Imported Successfully.",
  JOBS_PRINTED_SUCCESS: "Barcode generation process initiated successfuly",
  JOBS_FAILURE_STATUS: "Jobs  Submission Failed. Please try again later.",
  PREVIEW_FAILURE: "Preview Failed. Please try again later.",
  FILE_DOWNLOAD_SUCCESS: "File Downloaded Successfully.",
  FILE_DOWNLOAD_FAILED: "Download Failed. Please try again later.",
  PICTURE_ADD_SUCCESS: "Picture Added Successfully.",
  ALLOW_ONLY_IMAGE_FILES: "Only image files are allowed.",
  ALLOW_ONLY_SINGLE_FILE: "Please upload only one file at a time.",
  SAMPLE_FILE_UPLOAD_FAILURE:
    "Upload the correct file. 'Sample No.' column is missing or empty.",
  TISSUE_FILE_UPLOAD_FAILURE:
    "Upload the correct file. 'ir_SampleID' column is missing or empty.",
  SELECT_SAMPLE_FILE: "Please select a file to upload. ",
  FIELD_BOOK_UPDATE_ERROR: "Fieldbook Update Failed. Please try again later",
  SAMPLE_SAVE_SUCCESS: "Sample Saved Successfully .",
  LARGE_IMAGE_SIZE_ERROR: "Maximum upload file size : 25 MB",
  BLOCK_AND_FILLER_OVERLAP_ERROR:
    "There is an overlap in some of the selected boundary",
  SUBBLOCK_DELETION_FAILED:
    "All the blocks are overlapping with the selected boundary.",
  SUBBLOCK_DELETION_PARTIAL_SUCCESS:
    "Sub block deletion partially succesfull. Some blocks are overlapping with the selected boundary.",
  SUBBLOCK_DELETION_SUCCESS: "All selected sub blocks deleted successfully.",
  BLOCK_OVERLAP_ERROR: "There is an overlap in the selected boundary.",
  FILLER_OVERLAP_ERROR: "There is an overlap with the filler plot",
  BLOCK_CREATION_ERROR:
    "Some plots does not seem to be applicable for block formation. Please retry with some valid plots.",
  FILLER_REMOVAL_ERROR: "No Filler Plot is available in the selected boundary.",
  EMPTY_PLOT_FILLER_CREATION_ERROR:
    "Please select some valid plots as per the selected Field Map Type.",
  USED_PLOT_FILLER_CREATION_ERROR:
    "There is an overLap with the already used Plot.",
  BLOCK_DELETION_ERROR: "please Select some Block to delete.",
  NO_BLOCK_SELECTED_ERROR: "No block selected, please select some blocks",
  EMPTY_BLOCK_REMOVAL_ERROR: "Please select an empty block to remove.",
  ACTIVE_BLOCK_REMOVAL_SUCCESS: "Active block removed successfully.",
  ACTIVE_BLOCK_UNSELECT_SUCCESS: "Active blocks deactivated successfully.",
  ACTIVE_BLOCK_UNSELECT_ERROR: "No active block is available for this operation.",
  EXPORT_FIELD_MAP_ERROR:
    "Field Map data could not be exported. Please try again later.",
  LINEGRAPHICS_CREATION_SUCCESS:
    "Line graphics created and added to the new layer",
  EMPTY_BLOCKGRAPHICSLAYER_ERROR:
    "Please create a block for placing the trials.",
  EMPTY_BLOCK_TRIAL_PLACEMENT_ERROR:
    "Please select a block for placing the trials.",
  RESEARCH_EMPTY_PLOT_BLOCK_CREATION_ERROR: "Please select valid plots from Research Grid.",
  DEMO_EMPTY_PLOT_BLOCK_CREATION_ERROR: "Please select valid plots from Demo Grid.",
  EMPTY_PLOT_DELETION_ERROR: "Please select some plots to delete.",
  BLOCKGRAPHICSLAYER_NULL_ERROR: "No any block layer found.",
  EMPTY_TRIAL_RXMAP_ERROR:
    "No trial placement found inside the RXMap boundary.",
  FIELD_MAP_LOADING_ERROR: "Unable to load the Field Map. Please try again later.",
  FIELD_MAP_LAYER_SAVE_SUCCESS: "FieldMap layers saved successfully.",
  FIELD_MAP_FEATURE_SERVICE_PUBLISHED_SUCCESS:
    "Fieldmap feature service saved and published successfully.",
  READY_TO_PLACED_REP_SELECTION_ERROR: "Please select reps/groups with status R only.",
  PLACED_REP_SELECTION_ERROR: "Please select reps/groups with status P only.",
  NO_REP_SELECTION_ERROR: "Please select some reps/groups to be deleted.",
  SHAPEFILE_UPLOAD_ERROR: "Error in uploading shapeFile, Please upload again.",
  FIELDMAP_MAXRECORD_EXCEED_ERROR:
    "Maximum of 16,000 features are allowed in the Grid.",
  FIELDMAP_SAVE_ERROR:
    "Error saving the Field Map layers. Please try again by clicking the Save 'Field Map/Save Grid' button.",
  FIELDMAP_PUBLISH_ERROR:
    "Unable to save/publish the Field Map changes. Please try again later.",
  FIELDMAP_LOADING_ERROR:
    "Unable to load the Field Map. Please try again later.",
  FIELDMAP_UNAUTHORIZED_ERROR:
    "You are not authorized to access this Field Map.",
  FIELDMAP_DELETE_CONFIRMATION: "Are you sure you want to delete the field map associated with this location.",
  FIELDMAP_DISCARD_MODIFICATION: "There are unsaved Changes. Do you want to discard the changes and Switch FieldMap type?",
  FIELDMAP_UNSAVED_ERROR: "Please save the fieldMap changes before switching the fieldmap type.",
  FIELDMAP_NAVIGATION_TO_FIELDBOOK_UNSAVED_ERROR: "Please save the fieldMap changes before navigating to field book.",
  PLOT_DISCARDED_REASON_ERROR:
    "Discard Reason are required when plot is discarded.",
  MOISTURE_LIMIT_ERROR: "Moisture value should not be greater than 100.",
  FIELDMAP_SAVING_MESSAGE: "Please save before exiting from Field Map.",
  EMPTY_PLOT_COPY_CUT_ERROR:
    "Please select some valid plots to perform copy or cut operation.",
  USED_PLOT_COPY_CUT_ERROR: "You cannot cut the already used plots.",
  GRAPHICS_EDIT_SUCCESS: "Grid editing operation completed successfully.",
  REPDETAIL_ERROR: "Please verify the rep Ids in the CSV file.",
  VIEW_CREATED: "View Created Successfully.",
  VIEW_UPDATED: "View Updated Successfully.",
  VIEW_RESET: "View Reset Successfully.",
  VIEW_SET_AS_DEFAULT: "View Set as Default Successfully.",
  VIEW_SHARED: "View Shared Successfully.",
  VIEW_ALREADY_EXIST: "View with this name already exists.",
  TREATMENT_GROUP_INACTIVE_ERROR:
    "One of the selected Treatment is inactive. Please select an active Treatment Group.",
  SHAPEFILE_INVALID_ERROR:
    "The uploaded shapefile is invalid. Please check the file and try again.",
  UNIQUE_NAME_VARIANT_ERROR:
    "Seed Care Inventory name must be unique for the Variants.",
  NEWGRAPHIC_OVERLAP_ERROR:
    "New plots are overlaping with the already used plots.",
  OBSERVATION_SAVE_SUCCESS: "Observation Data saved successfully.",
  CONTRACTOR_NOT_EDITABLE_MSG:
    "This checkbox is disabled because reps have already been created for this location.",
  TREATMENT_ADDED_SUCCESSFULLY: "Treatment Added Successfully.",
  TREATMENT_DELETED_FAIL: "Failed To Delete Treatment.",
  DEFAULT_ERROR_MESSAGE: "Something went wrong!",
  NO_DATA_EXPORT_FILE_ERROR: "No data found to export.",
  ARCGIS_ONLINE_FS_ERROR:
    "Field Map is not available in Arcgis Enterprise for the selected location.",
  DELETE_USER_VIEW: "View Deleted Successfully.",
  PRINCIPAL_INVESTIGATOR_TOOLTIP:
    "Executes the trial according to the protocol, ensuring correct treatment application, accurate data collection, and day-to-day operational management.",
  TREATMENT_PRODUCT_APPROVED: "Treatment Product Approved Successfully.",
  TRIAL_AUTHOR_TOOLTIP:
    " Designs the research trial and writes the complete protocol, including treatments, objectives, design, data needs, and methodology.",
  UNSAVED_CHANGES_MESSAGE:
    "You have unsaved changes, are you sure you want to leave?",
  PRINTING_QUEUED: "Print job is Queued.",
  PRINTING_COMPLETED: "Receipts Generated Successfully.",
  PRINTING_FAILED: "Receipts Generation Failed.",
  GROUP_NUMBER_MANDATORY: "All products require a group number before publishing.",
  DEMO_TRIAL_PRODUCT_UPDATE: "Products Updated Successfully.",
  DUPLICATE_RANGE_ROW_CHECK: "Duplicate range and rows are not allowed in the grid.",
  TRIAL_EXPERIMENTS_STATUS_UPDATE_SUCCESS: "Trial Status Updated Successfully."
};
